import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconGhostAgent = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 2.5C7.35046 2.5 3.40611 5.98784 3.03778 10.655C2.82041 13.4093 2.6386 16.4547 2.64832 18.8656C2.65553 20.654 4.37439 21.7802 6.00739 21.3136L6.54862 21.159C6.81497 21.0829 7.09906 21.0974 7.35626 21.2003L8.47866 21.6492C9.13429 21.9115 9.86568 21.9115 10.5213 21.6492L11.5357 21.2435C11.8338 21.1243 12.1662 21.1243 12.4642 21.2435L13.4787 21.6492C14.1343 21.9115 14.8657 21.9115 15.5213 21.6492L16.6437 21.2003C16.9009 21.0974 17.185 21.0829 17.4514 21.159L17.9926 21.3136C19.6256 21.7802 21.3444 20.654 21.3517 18.8656C21.3614 16.4547 21.1796 13.4093 20.9622 10.655C20.5939 5.98783 16.6495 2.5 12 2.5ZM4.53313 10.773C4.83737 6.91789 8.1008 4 12 4C15.8992 4 19.1626 6.91789 19.4669 10.773C19.6834 13.5169 19.8611 16.5125 19.8517 18.8595C19.8488 19.5647 19.1694 20.0898 18.4047 19.8713L17.8634 19.7167C17.2775 19.5493 16.6525 19.5812 16.0866 19.8076L14.9642 20.2565C14.6662 20.3757 14.3338 20.3757 14.0357 20.2565L13.0213 19.8508C12.3657 19.5885 11.6343 19.5885 10.9787 19.8508L9.96422 20.2565C9.66621 20.3757 9.33376 20.3757 9.03575 20.2565L7.91334 19.8076C7.3475 19.5812 6.72251 19.5493 6.13653 19.7167L5.59531 19.8713C4.83062 20.0898 4.15115 19.5647 4.14831 18.8595C4.13885 16.5125 4.31657 13.5169 4.53313 10.773Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.25 9.5C8.66421 9.5 9 9.83579 9 10.25V12.75C9 13.1642 8.66421 13.5 8.25 13.5C7.83579 13.5 7.5 13.1642 7.5 12.75V10.25C7.5 9.83579 7.83579 9.5 8.25 9.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 10.25C16.5 9.83579 16.1642 9.5 15.75 9.5C15.3358 9.5 15 9.83579 15 10.25V12.75C15 13.1642 15.3358 13.5 15.75 13.5C16.1642 13.5 16.5 13.1642 16.5 12.75V10.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.25 14C10.8358 14 10.5 14.3358 10.5 14.75C10.5 15.1642 10.8358 15.5 11.25 15.5H12.75C13.1642 15.5 13.5 15.1642 13.5 14.75C13.5 14.3358 13.1642 14 12.75 14H11.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconGhostAgent as ReactComponent };
